import { render, staticRenderFns } from "./HelpDesksIssueForm.vue?vue&type=template&id=6c05b01b"
import script from "./HelpDesksIssueForm.vue?vue&type=script&lang=js"
export * from "./HelpDesksIssueForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports